import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(): boolean {
    let user = localStorage.getItem('userMobileNo') ?? '';
    if (user?.length === 0) {
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }
}
